<template>
  <v-container grid-list-sm text-xs-center>
    <v-layout row wrap>
      <v-flex xs11>
        <form autocomplete="off">
          <v-layout row wrap align-center>
            <v-flex sm3 subheading>
              Roles: 
            </v-flex>
            <v-flex sm9>
              <v-autocomplete :items="allRoles" v-model="roleIds" label="Select" item-text="name" item-value="id" multiple chips :menu-props="{maxHeight:'auto'}">
                <template slot="roleIds" slot-scope="data">
                  <v-chip :selected="data.selectedRoles" :key="JSON.stringify(data.item)" close class="chip--select-multi" @input="data.parent.selectItem(data.item)">
                    {{ data.item.name }}
                  </v-chip>
                </template>
                <template slot="item" slot-scope="data">
                  <template v-if="typeof data.item !== 'object'">
                    <v-list-tile-content v-text="data.item"></v-list-tile-content>
                  </template>
                  <template v-else>
                    <v-list-tile-content>
                      <v-list-tile-title v-html="data.item.name"></v-list-tile-title>
                    </v-list-tile-content>
                  </template>
                </template>
              </v-autocomplete>
            </v-flex>
            
            <v-flex sm3 subheading>Projects: </v-flex>
            <v-flex sm9>
              <v-autocomplete :items="allProjects" v-model="projectIds" label="Select" item-text="name" item-value="id" multiple chips :menu-props="{maxHeight:'auto'}">
                <template slot="projectIds" slot-scope="data">
                  <v-chip :selected="data.selectedProjects" :key="JSON.stringify(data.item)" close class="chip--select-multi" @input="data.parent.selectItem(data.item)">
                    {{ data.item.name }}
                  </v-chip>
                </template>
                <template slot="item" slot-scope="data">
                  <template v-if="typeof data.item !== 'object'">
                    <v-list-tile-content v-text="data.item"></v-list-tile-content>
                  </template>
                  <template v-else>
                    <v-list-tile-content>
                      <v-list-tile-title v-html="data.item.name"></v-list-tile-title>
                    </v-list-tile-content>
                  </template>
                </template>
              </v-autocomplete>
            </v-flex>
              
            <v-flex sm3 subheading>First Name: </v-flex>
            <v-flex sm9>
              <v-text-field v-model="firstName" label="First Name" required @blur="$v.firstName.$touch()" :error-messages="firstNameErrorMsgs"></v-text-field>
            </v-flex>
              
            <v-flex sm3 subheading>Last Name: </v-flex>
            <v-flex sm9>
             <v-text-field v-model="lastName" label="Last Name" required @blur="$v.lastName.$touch()" :error-messages="lastNameErrorMsgs"></v-text-field>
            </v-flex>
              
            <v-flex sm3 subheading>Company: </v-flex>
            <v-flex sm9>
              <v-text-field v-model="company" label="Company"></v-text-field>
            </v-flex>
              
            <v-flex sm3 subheading>Timezone:</v-flex>
            <v-flex sm9>
              <v-autocomplete :items="allTimezones" v-model="timezone" label="Select" item-text="name" item-value="name"  hint="Select Timezone">
                <template slot='items' slot-scope='timezones'>{{ timezones.item.name }}</template>
              </v-autocomplete>
            </v-flex>
              
            <v-flex sm3 subheading>Email: </v-flex>
            <v-flex sm9>
              <v-text-field v-model="email" label="Email" required @input="$v.email.$touch()" @blur="$v.email.$touch()" :error-messages="emailErrorMsgs"></v-text-field>
            </v-flex>
              
            <v-flex sm3 subheading>Password: </v-flex>
            <v-flex sm9>
              <v-text-field v-model="password" autocomplete="off" :error-messages="passwordErrorMsgs" :append-icon="passwordVisibility ? 'visibility' : 'visibility_off'" @click:append="() => (passwordVisibility = !passwordVisibility)" :type="passwordVisibility ? 'password' : 'text'" label="Password" required @blur="$v.password.$touch()"></v-text-field>
            </v-flex>
              
            <v-flex sm3 subheading>Active: </v-flex>
            <v-flex sm9>
              <v-checkbox v-model="active" hide-details color="primary"></v-checkbox>
            </v-flex>

          </v-layout>
            
          <v-btn @click="submit">Submit</v-btn>
          <v-btn @click="cancel">Cancel</v-btn>
        </form>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<style scoped>
.full-width{
  width: 100%
}
</style>

<script>
import vh, {firstName, lastName, email, password} from '@/helpers/validators'
import { getUDT } from '@/helpers/formatters'
import momenttz from 'moment-timezone'
import axios from 'axios'
import { mapGetters, mapMutations, mapActions } from 'vuex'

export default {
  props: ['id'],
  data () {
    return {
      passwordVisibility: true,
      firstName: '',
      lastName: '',
      company: '',
      timezone: '',
      email: '',
      password: '',
      active: false,
      confirmedAt: {},
      lastLoginAt: {},
      currentLoginAt: {},
      lastLoginIp: '0.0.0.0',
      currentLoginIp: '0.0.0.0',
      loginCount: 0,
      projectIds: [],
      projects: [],
      roleIds: [],
      roles: []
    }
  },
  validations: {
    firstName: vh.vrules(firstName),
    lastName: vh.vrules(lastName),
    email: vh.vrules(email),
    password: vh.vrules(password)
  },
  computed: {
    ...mapGetters({
      allRoles: 'getRoles',
      allProjects: 'getProjects',
      getUserById: 'getUserById',
      getProjectById: 'getProjectById',
      getRoleById: 'getRoleById'
    }),
    emailErrorMsgs () {
      if (this.$v.email.$dirty) {
        return vh.vmsg(this.$v.email, email)
      } else {
        return []
      }
    },
    passwordErrorMsgs () {
      if (this.$v.password.$dirty) {
        return vh.vmsg(this.$v.password, password)
      } else {
        return []
      }
    },
    firstNameErrorMsgs () {
      if (this.$v.firstName.$dirty) {
        return vh.vmsg(this.$v.firstName, firstName)
      } else {
        return []
      }
    },
    lastNameErrorMsgs () {
      if (this.$v.lastName.$dirty) {
        return vh.vmsg(this.$v.lastName, lastName)
      } else {
        return []
      }
    },
    allTimezones () {
      var tmz = momenttz.tz.names()
      return tmz
    }
  },
  methods: {
    ...mapMutations('notification', ['notify']),
    ...mapActions({ addUser: 'addUser' }),
    getData () {
      axios.all([this.$store.dispatch('getRoles'), this.$store.dispatch('getProjects')]).then(axios.spread((rolesResponse, projectsResponse) => {
        if (rolesResponse.data.status === 'SUCCESS' && projectsResponse.data.status === 'SUCCESS') {
          this.$store.commit('setRoles', rolesResponse.data.payload)
          this.$store.commit('setProject', projectsResponse.data.payload)
        } else {
          this.notify({message: 'Something went wrong while fetching data.', show: true})
        }
      })).catch((err) => {
        this.notify({message: 'Something went wrong while connecting to the server.', show: true})
        console.log(err)
      })
    },
    submit () {
      this.$v.$touch()
      if (this.$v.$invalid) return
      this.submitData()
    },
    submitData () {
      var dateObject = getUDT()

      this.projects = []
      for (var i1 = 0; i1 < this.projectIds.length; i1++) {
        this.projects.push(this.getProjectById(this.projectIds[i1]))
      }

      this.roles = []
      for (var i2 = 0; i2 < this.roleIds.length; i2++) {
        this.roles.push(this.getRoleById(this.roleIds[i2]))
      }

      if (!this.id) {
        var newUser = {
          firstName: this.firstName,
          lastName: this.lastName,
          company: this.company,
          timezone: this.timezone,
          email: this.email,
          password: this.password,
          active: this.active,
          confirmedAt: dateObject,
          lastLoginAt: dateObject,
          currentLoginAt: dateObject,
          lastLoginIp: this.lastLoginIp,
          loginCount: this.loginCount,
          currentLoginIp: this.currentLoginIp,
          projects: this.projects,
          roles: this.roles
        }

        axios.all([this.$store.dispatch('addUser', newUser)]).then(axios.spread((usersResponse) => {
          if (usersResponse.data.status === 'SUCCESS') {
            this.$store.commit('addUser', usersResponse.data.payload)
            this.$router.push('./')
          } else {
            this.notify({message: 'Something went wrong while creating user.', show: true})
          }
        })).catch((err) => {
          this.notify({message: 'Something went wrong while connecting to the server.', show: true})
          console.log(err)
        })
      } else {
        var userUpdate = {
          id: Number(this.id),
          firstName: this.firstName,
          lastName: this.lastName,
          company: this.company,
          timezone: this.timezone,
          email: this.email,
          password: this.password,
          active: this.active,
          confirmedAt: dateObject,
          lastLoginAt: dateObject,
          currentLoginAt: dateObject,
          lastLoginIp: this.lastLoginIp,
          loginCount: this.loginCount,
          currentLoginIp: this.currentLoginIp,
          projects: this.projects,
          roles: this.roles
        }

        axios.all([this.$store.dispatch('updateUser', userUpdate)]).then(axios.spread((usersResponse) => {
          if (usersResponse.data.status === 'SUCCESS') {
            this.$store.commit('updateUser', usersResponse.data.payload)
            this.$router.push('./')
          } else {
            this.notify({message: 'Something went wrong while updating user.', show: true})
          }
        })).catch((err) => {
          this.notify({message: 'Something went wrong while connecting to the server.', show: true})
          console.log(err)
        })
      }
    },
    cancel () {
      this.$router.push('./')
    }
  },
  mounted: function () {
    this.getData()
  },
  created () {
    if (!this.id) {
      return
    }

    const user = this.getUserById(this.id)

    if (!user) {
      this.$router.push('./')
      return
    }

    this.firstName = user.firstName
    this.lastName = user.lastName
    this.company = user.company
    this.timezone = user.timezone
    this.email = user.email
    this.password = user.password
    this.active = user.active
    this.confirmedAt = user.confirmedAt
    this.lastLoginAt = user.lastLoginAt
    this.currentLoginAt = user.currentLoginAt
    this.lastLoginIp = user.lastLoginIp
    this.currentLoginIp = user.currentLoginIp
    this.loginCount = user.loginCount
    this.roles = user.roles
    this.projects = user.projects
    this.roleIds = []
    this.projectIds = []
    for (var i1 = 0; i1 < this.roles.length; i1++) {
      this.roleIds.push(Number(this.roles[i1].id))
    }
    for (var i2 = 0; i2 < this.projects.length; i2++) {
      this.projectIds.push(Number(this.projects[i2].id))
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/users/User.vue